
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 76.77 301.52"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.38 244.17a28.68 28.68 0 1028.68 28.68 28.71 28.71 0 00-28.68-28.68zm0 46.39a17.71 17.71 0 1117.71-17.71 17.74 17.74 0 01-17.71 17.71zM75.34 1.8A5.46 5.46 0 0071.28 0H5.48a5.44 5.44 0 00-4.05 1.8A5.51 5.51 0 000 6l20.22 209.6a5.49 5.49 0 005.46 4.95h25.38a5.48 5.48 0 005.46-4.95L76.74 6a5.46 5.46 0 00-1.4-4.2zM46.08 209.6h-15.4L11.52 11h53.73z"}}),_c('path',{attrs:{"d":"M40.64 75.9H41a5.49 5.49 0 005.47-5.14l2.73-42.94a5.48 5.48 0 00-10.94-.7l-2.75 42.95a5.51 5.51 0 005.13 5.83z"}})])
          )
        }
      }
    